import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { thunk } from 'redux-thunk';
import createRootReducer from './reducers';

const configureStore = (history) => {
  const middleware = [routerMiddleware(history), thunk];

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    createRootReducer(history),
    composeEnhancers(applyMiddleware(...middleware))
  );

  return store;
};

export default configureStore;
